<template>
  <div class="relative">
    <div ref="container_tree" class="bg-successs overflow-auto p-3" style="height: 450px">
      <div class="label-question flex items-center">
        <span>{{ question.label }}</span>
      </div>

      <div class="Tree relative ml-4 md:ml-16 border border-t-0 border-r-0 border-b-0 pt-3 pl-8 border-dashed">
        <div class="tree-items my-2 mb-5" v-for="(item, j) in listStandard" :key="j">
          <div class="flex flex-col md:flex-row w-full">
            <div class="flex w-full md:w-auto z-50">
              <div class="toggle mr-2 pt-1">
                <button
                  :ref="`disminute_${j}`"
                  class="rounded border px-1 pt-1 bg-white cursor-pointer"
                  @click="AddTransition(j)"
                >
                  <i class="material-icons" style="font-size: 16px"> expand_more </i>
                </button>
              </div>
              <div class="class-condition w-full md:w-full p-2 mr-0 md:mr-3 rounded-lg text-center border">
                <span>{{ getType(question).type_condition }}</span>
              </div>
            </div>

            <div class="mr-5 w-full md:w-1/2 py-2 md:py-0">
              <components
                v-model.trim="item.answer"
                :is="getType(question).component"
                :Item="item"
                :question="question"
                :change="changeValue"
              ></components>
            </div>

            <div class="flex border md:border-0 border-t-0 border-l-0 border-r-0 border-dashed pb-2 md:pb-0">
              <div class="mr-1 md:mr-5 w-full md:w-auto">
                <button
                  @click="removeDependency(j)"
                  class="
                    h-full
                    w-full
                    md:w-auto
                    rounded-full
                    border
                    p-3
                    px-4
                    font-bold
                    border-danger
                    text-danger
                    bg-white
                    cursor-pointer
                  "
                >
                  {{ $t(`MODALS.modalDependencias.remove`) }}
                </button>
              </div>
              <div class="w-full">
                <button
                  class="
                    h-full
                    w-full
                    md:w-auto
                    rounded-full
                    border
                    p-3
                    border-success
                    text-success
                    bg-white
                    cursor-pointer
                  "
                  @click="
                    active = true;
                    indexAdd = j;
                  "
                >
                  {{ $t(`MODALS.modalDependencias.add`) }}
                </button>
              </div>
            </div>
          </div>

          <div
            :ref="`Tree_${j}`"
            class="Tree relative ml-0 md:ml-16 border border-t-0 border-r-0 border-b-0 pt-3 pl-8 border-dashed"
          >
            <div class="tree-items my-1 sub-level mb-3 md:mb-0" v-for="(question, i) in item.children" :key="i">
              <div class="flex flex-col md:flex-row w-full">
                <div class="mr-5 w-full md:w-96">
                  <div class="h-full w-full md:w-96 py-2 md:py-0 hidden md:flex rounded-lg border px-2 items-center">
                    {{ question.label }}
                  </div>
                  <div
                    class="h-full w-full md:w-96 py-2 md:py-0 flex md:hidden rounded-t-lg border px-2 flex items-center"
                  >
                    {{ question.label }}
                  </div>
                </div>
                <div class="mr-5 w-full md:inline-block">
                  <button
                    class="
                      hidden
                      md:inline-block
                      h-full
                      rounded-full
                      border
                      p-3
                      px-4
                      font-bold
                      border-danger
                      text-danger
                      bg-white
                      cursor-pointer
                    "
                    @click="removeQuestion(j, i, question)"
                  >
                    X
                  </button>
                  <button
                    class="
                      inline-block
                      md:hidden
                      h-full
                      w-full
                      rounded-b
                      border
                      p-1
                      px-4
                      font-bold
                      border-danger
                      text-danger
                      bg-white
                      cursor-pointer
                    "
                    @click="removeQuestion(j, i, question)"
                  >
                    {{ $t(`MODALS.modalDependencias.delete`) }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="tree-add flex flex-col md:flex-row mt-5">
          <div class="class-condition w-full md:w-1/4 p-2 mr-3 rounded-lg text-center border">
            <span>{{ getType(question).type_condition }}</span>
          </div>
          <div class="condition w-full md:w-1/2 mr-3 py-2 md:py-0">
            <components
              v-model.trim="answer"
              :is="getType(question).component"
              :Item="{ answer: answer, children: null }"
              :question="question"
              :change="e => {}"
              @validate="validate = $event"
            ></components>
            <!-- <input v-model.trim="answer" class="h-full rounded-lg w-96 border px-2" type="text" /> -->
          </div>
          <div>
            <button
              :disabled="disabled"
              :class="{
                btn_disabled: disabled,
                'border-success text-success cursor-pointer': !disabled
              }"
              class="h-full w-full md:w-0 rounded-lg border p-3 bg-white"
              @click="active = true"
            >
              {{ $t(`MODALS.modalDependencias.show`) }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <ListItems v-if="active" :active.sync="active" @questionsSelected="questionsSelected" />
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { createDependence, deleteDependenceChild } from "@/serviforms/designer/indexDB/dependencies.js";
import { dataStandard, formatAnswers } from "./standard";
import ListItems from "./components/ItemsList.vue";
import { Components } from "./components_/standard/index";
export default {
  components: { ListItems, ...Components },
  async mounted() {
    const data = await dataStandard(this.question.name);
    const result = await formatAnswers(data);
    this.listStandard = result;
    for(const questions of this.allPages) this.allQuestions.push(...questions.questions);
  },
  data() {
    return {
      active: false,
      indexAdd: null,
      answer: "",
      listStandard: [],
      validate: true,
      allQuestions: []
    };
  },
  methods: {
    ...mapActions("resource", ["getCreatedDependencies"]),
    /**
     * Se optienen las preguntas seleccionadas y se agregan a la dependencia de la pregunta padre.
     * @param { Array } questions - Array de preguntas
     */
    async questionsSelected(questions) {
      let _answer = this.answer;
      let relatedness = "simple";
      let answer = "answer";

      if (this.indexAdd === null) {
        const data = {
          answer: this.answer,
          children: questions
        };
        this.listStandard.push(data);
      } else {
        this.listStandard[this.indexAdd].children.push(...questions);
        _answer = this.listStandard[this.indexAdd].answer;
      }

      if (Array.isArray(_answer)) {
        relatedness = "multiple";
        answer = "answers";
      }

      for (var question of questions) {
        const related = {
          name: this.question.name,
          // question: this.indexQuestion,
          question: this.allQuestions.findIndex(question => question.name === this.question.name),
          relatedness: relatedness,
          [answer]: _answer
        };
        await createDependence(this.question.name, question.name, related);
      }
      this.indexAdd = null;
      this.answer = "";
      this.scrollTop();
      this.getCreatedDependencies();
    },
    AddTransition(j) {
      const Tree = this.$refs[`Tree_${j}`];
      Tree[0].classList.toggle("h-none");
      Tree[0].classList.toggle("overflow-hidden");
      Tree[0].classList.toggle("border-none");
      this.isDisminute(j);
    },
    isDisminute(j) {
      const Tree = this.$refs[`Tree_${j}`];
      if (Tree !== undefined) {
        const result = Tree[0].classList.contains("h-none");
        const disminute = this.$refs[`disminute_${j}`];

        if (result)
          return (disminute[0].innerHTML = '<i class="material-icons" style="font-size:16px"> chevron_right  </i>');
        return (disminute[0].innerHTML = '<i class="material-icons" style="font-size:16px"> expand_more </i>');
      }
      return (disminute[0].innerHTML = '<i class="material-icons" style="font-size:16px"> expand_more </i>');
    },
    /**
     * Se remuve una pregunta hija del arbol de dependencias
     */
    async removeQuestion(j, i, question) {
      this.listStandard[j].children.splice(i, 1);
      if (this.listStandard[j].children.length === 0) {
        this.listStandard.splice(j, 1);
      }
      await deleteDependenceChild(this.question.name, question.name);
      this.getCreatedDependencies();
    },
    /**
     * Se remueven el conjunto de dependencias hijas del arbol de dependencias.
     * @param {string} j - ID de la prgunta padre.
     */
    async removeDependency(j) {
      for (var question of this.listStandard[j].children)
        await deleteDependenceChild(this.question.name, question.name);
      this.listStandard.splice(j, 1);
      this.getCreatedDependencies();
    },
    async changeValue(_answer, value) {
      let relatedness = "simple";
      let answer = "answer";

      if (Array.isArray(value.answer)) {
        relatedness = "multiple";
        answer = "answers";
      }

      for (var question of value.children) {
        const related = {
          name: this.question.name,
          question: this.indexQuestion,
          relatedness: relatedness,
          [answer]: _answer
        };
        await createDependence(this.question.name, question.name, related);
      }
    },
    getType(question) {
      switch (question.type) {
        case "boolean":
          return {
            type_condition: `Igual a`,
            component: "Boolean"
          };
        case "input": {
          return this.getInpuType(question.inputType);
        }
        case "choice": {
          return this.getInpuType(question.inputType);
        }
        case "photo": {
          return this.getInpuType(question.inputType);
        }
        default: {
          return {
            type_condition: ``,
            component: ""
          };
        }
      }
    },
    getInpuType(inputType) {
      switch (inputType) {
        case "default":
        case "domain":
        case "phone":
        case "textarea":
        case "ipv4":
        case "ipv6": {
          return {
            type_condition: this.$t(`MODALS.modalDependencias.textEquals`),
            component: "Texto"
          };
        }
        case "password": {
          return {
            type_condition: this.$t(`MODALS.modalDependencias.passEquals`),
            component: "Password"
          };
        }
        case "email": {
          return {
            type_condition: this.$t(`MODALS.modalDependencias.emailEquals`),
            component: "Email"
          };
        }
        case "slider": {
          return {
            type_condition: this.$t(`MODALS.modalDependencias.sliderEquals`),
            component: "Slider"
          };
        }
        case "ranking": {
          return {
            type_condition: this.$t(`MODALS.modalDependencias.rankingEquals`),
            component: "Ranking"
          };
        }
        case "number": {
          return {
            type_condition: this.$t(`MODALS.modalDependencias.numberEquals`),
            component: "Number"
          };
        }
        case "currency": {
          return {
            type_condition: this.$t(`MODALS.modalDependencias.valueEquals`),
            component: "Currency"
          };
        }
        case "radio":
        case "radioOther": {
          return {
            type_condition: this.$t(`MODALS.modalDependencias.uniqueValue`),
            component: "UniqueChoice"
          };
        }
        case "multi":
        case "multiOther": {
          return {
            type_condition: this.$t(`MODALS.modalDependencias.multiValues`),
            component: "MultiChoice"
          };
        }
        case "barcode": {
          return {
            type_condition: this.$t(`MODALS.modalDependencias.codebarEquals`),
            component: "Barcode"
          };
        }
        case "gallery":
        case "gallery/camera":
        case "camera":
        case "QRReader": {
          return {
            type_condition: this.$t(`MODALS.modalDependencias.emptyFull`),
            component: "Boolean"
          };
        }
        default: {
          return {
            type_condition: ``,
            component: ""
          };
        }
      }
    },
    scrollTop() {
      const div = this.$refs["container_tree"];
      div.scrollTop = div.scrollHeight;
    }
  },
  computed: {
    ...mapState("resource", ["indexQuestion", "questionsByPage", "allPages", "AllQuestions"]),
    question() {
      return this.questionsByPage[this.indexQuestion];
    },
    disabled() {
      if (!this.validate) return true;
      return this.answer === null || this.answer === "0" || this.answer.length === 0;
    }
  },
};
</script>

<style lang="scss" scoped>
.tree-add::before {
  content: "";
  width: 2rem;
  height: 1.5rem;
  border: 1px dashed #dae1e7;
  border-left: 1px solid white;
  position: absolute;
  left: -1px;
  bottom: -2px;
  border-bottom: 0px;
  border-right: 0px;
}

.tree-items::before {
  content: "";
  width: 2rem;
  height: 1.5rem;
  border: 1px dashed #dae1e7;
  position: absolute;
  left: 0;
  border-right: 0px;
  border-bottom: 0px;
  border-left: 0px;
  margin-top: 1.1rem;
}

.sub-level:last-child::before {
  content: "";
  width: 2rem;
  height: 4.5rem;
  position: absolute;
  left: -1px;
  border-left: 1px solid white;
}

.w-96 {
  width: 28rem;
}

.btn_disabled {
  cursor: not-allowed;
  border-color: #f2f2f2;
  color: #f2f2f2;
}

.h-none {
  height: 0px !important;
}

.border-none {
  border: none !important;
}
</style>
